import React from "react";
import { Link } from "react-router-dom";
import { Zap, MapPin, Clock, Mail, Phone, Facebook, ArrowUpRight } from "lucide-react";
import { company } from "../mock";

export default function Footer() {
  return (
    <footer className="relative bg-neutral-950 text-neutral-300 overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-amber-400 flex items-center justify-center">
              <Zap className="w-5 h-5 text-neutral-950" />
            </div>
            <div>
              <div className="font-display font-bold text-xl text-white">Elorte-Medarić</div>
              <div className="text-xs uppercase tracking-widest text-neutral-500">d.o.o. • Jelah, BiH</div>
            </div>
          </div>
          <p className="mt-5 text-neutral-400 max-w-md leading-relaxed">
            Proizvodnja i projektovanje KPMO, KPO i GRMO ormara od vakumiranih PVC ploča njemačkog
            proizvođača Kömmerling.
          </p>
          <a
            href={company.facebook}
            target="_blank"
            rel="noreferrer"
            className="mt-6 inline-flex items-center gap-2 text-sm text-amber-400 hover:text-amber-300 transition-colors"
          >
            <Facebook className="w-4 h-4" /> Prati nas na Facebook-u
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-4">Navigacija</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-amber-400 transition-colors">Početna</Link></li>
            <li><Link to="/proizvodi" className="hover:text-amber-400 transition-colors">Proizvodi</Link></li>
            <li><Link to="/kontakt" className="hover:text-amber-400 transition-colors">Kontakt</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-4">Kontakt</div>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2"><MapPin className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" /> Rosulje 77, 74264 Jelah</li>
            <li className="flex gap-2"><Clock className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" /> Pon – Pet 08:00 – 16:00</li>
            <li className="flex gap-2"><Phone className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" /> {company.phone}</li>
            <li className="flex gap-2"><Mail className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" /> info@elorte-medaric.ba</li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-neutral-500">
            © {new Date().getFullYear()} Elorte-Medarić d.o.o. Sva prava zadržana.
          </p>
          <p className="text-xs text-neutral-500">Made in Jelah, Bosna i Hercegovina</p>
        </div>
      </div>
    </footer>
  );
}
